var _G;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import Svg, { G, Path } from "react-native-svg";
var SvgHudLeave = function SvgHudLeave(props) {
  return /*#__PURE__*/React.createElement(Svg, _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    fill: "none",
    overflow: "visible",
    preserveAspectRatio: "none",
    style: {
      display: "block"
    },
    viewBox: "0 0 20 20"
  }, props), _G || (_G = /*#__PURE__*/React.createElement(G, {
    stroke: "#F2F6FF",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.75
  }, /*#__PURE__*/React.createElement(Path, {
    d: "M8.333 3.333H5.417c-.692 0-1.25.559-1.25 1.25v10.834c0 .691.558 1.25 1.25 1.25h2.916M12.083 6.667 15.417 10l-3.334 3.333M15.417 10h-7.5"
  }))));
};
export default SvgHudLeave;